export default __webpack_public_path__ + "media/mock/src/img/logo-7e305d811ee1171e5d77a15194091e1a.svg";